/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import './style.css';
import Experience from './Experience/Experience.js';
import Driving from './driving';
const experience = new Experience(document.querySelector('canvas.webgl'));

const driving = new Driving();